import { SET_CLIENT_MONITOR_CONFIG, SET_CLIENT_MONITOR_CONFIG_FORBIDDEN } from '../../actionTypes/clientMonitorConfig'

export const setClientMonitorConfig = value => ({ type: SET_CLIENT_MONITOR_CONFIG, value })

export const setClientMonitorConfigForbidden = value => ({ type: SET_CLIENT_MONITOR_CONFIG_FORBIDDEN, value })
